import React from 'react';
import { Collapse } from 'react-bootstrap';

import CareMapprTextField from '../../../../../components/Inputs/textField/CareMapprTextField';
import CareMapprButton from '../../../../../components/Button/CareMapprButton';
import CareMapprDatePicker from '../../../../../components/DatePicker/CareMapprDatePicker';
import { useForm } from 'react-hook-form';

const AddAppointmentForm = ({ open, onClose, onSave }) => {
  const { register, getValues, watch, setValue, reset } = useForm({
    defaultValues: {
      apptType: '',
      apptDate: '',
      apptTime: '',
    },
  });
  const apptDate = watch('apptDate');
  const apptTime = watch('apptTime');
  const apptType = watch('apptType');
  const onClickSubmit = () => {
    const values = getValues();
    onSave(values);
    reset();
  };
  const onClickClose = () => {
    onClose();
    reset();
  };
  return (
    <Collapse in={open}>
      <div className="px-2">
        <span className="my-2 medication-profile-font-gray row-action-font">
          Add follow up appointment
        </span>
        <div className="my-3 font-sm">
          <div className="row">
            <div className="col-9">
              <div className="d-flex gap-2">
                <CareMapprTextField
                  label="Appointment type"
                  placeholder="e.g. GP, specialist etc"
                  {...register('apptType')}
                  value={apptType}
                  onChange={(event) => {
                    setValue('apptType', event.target.value);
                  }}
                />
                <CareMapprDatePicker
                  label="Date of appointment"
                  className="mb-0"
                  selectedDate={apptDate}
                  {...register('apptDate')}
                  controlId="apptDate"
                  onChange={(value) => {
                    setValue('apptDate', value);
                  }}
                />
                <CareMapprDatePicker
                  label="Time of appointment"
                  className="mb-0"
                  mode="time"
                  selectedDate={apptTime}
                  {...register('apptTime')}
                  onChange={(value) => {
                    setValue('apptTime', value);
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="d-flex gap-2">
                <CareMapprButton
                  variant="transparent"
                  label="Cancel & close"
                  labelClassName="medication-cancel-button"
                  onClick={onClickClose}
                />
                <CareMapprButton label="Save" onClick={onClickSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Collapse>
  );
};

export default AddAppointmentForm;
